import { BenchmarkWaterTestRequest } from "../../../../rest/benchmark/BenchmarkRepository";
import ProCheckDetailsPageState from "../model/ProCheckDetailsPageState";
import Property from "../../../../rest/properties/model/Property";


/**
 * Maps ProCheck test data to Benchmark API format
 */
export const mapProCheckToBenchmark = (
    proCheckData: ProCheckDetailsPageState,
    property: Property | undefined,
    engineerUuid: string
): BenchmarkWaterTestRequest => {
    const isNewInstall = proCheckData.system_info?.reason?.toLowerCase() === "new install";
    const type = isNewInstall ? 0 : 1; // 0 = New install, 1 = Service

    const serialNumber = proCheckData.system_info?.serialBoiler?.trim() || "";
    const postcode = property?.address_postcode?.trim() || "";
    const finalEngineerUuid = engineerUuid?.trim() || "";
    const methodology = buildMethodologyText(proCheckData);

    return {
        appliance_type_id: 1, // Domestic Boiler
        type,
        serial_number: serialNumber,
        postcode,
        engineer_uuid: finalEngineerUuid,
        inhibitor_concentration_test_used: "ADEY ProCheck",
        inhibitor_concentration_test_methodology: methodology,
    };
};

/**
 * Converts ProCheck test results into readable text
 */
const buildMethodologyText = (proCheckData: ProCheckDetailsPageState): string => {
    const parts: string[] = [];

    parts.push(`Overall: ${proCheckData.pass ? "Pass" : "Action Required"}`);

    if (proCheckData.results) {
        const { pH1, molybdate, iron, copper } = proCheckData.results;

        if (pH1) {
            parts.push(`pH: ${pH1.outcome} (${pH1.value})`);
        }
        if (molybdate) {
            parts.push(`Molybdate/Inhibitor: ${molybdate.outcome} (${molybdate.value})`);
        }
        if (iron) {
            parts.push(`Iron: ${iron.outcome} (${iron.value})`);
        }
        if (copper) {
            parts.push(`Copper: ${copper.outcome} (${copper.value})`);
        }
    }

    if (proCheckData.summary && proCheckData.summary.length > 0) {
        parts.push(`Summary: ${proCheckData.summary.join(", ")}`);
    }

    if (proCheckData.system_info) {
        if (proCheckData.system_info.type) {
            parts.push(`System: ${proCheckData.system_info.type}`);
        }
        if (proCheckData.system_info.reason) {
            parts.push(`Reason: ${proCheckData.system_info.reason}`);
        }
        if (proCheckData.system_info.filter !== undefined) {
            parts.push(`Filter: ${proCheckData.system_info.filter ? "Yes" : "No"}`);
        }
    }

    if (proCheckData.date) {
        parts.push(`Test Date: ${proCheckData.date}`);
    }

    if (proCheckData.notes) {
        parts.push(`Notes: ${proCheckData.notes}`);
    }

    return parts.join("; ");
};